import urlConfig from 'Url';

export const SAVE_SELECT_DATE = 'SAVE_SELECT_DATE';
export const CLEAR_SELECT_DATE = 'CLEAR_SELECT_DATE';
export const REPLEACE_SELECT_DATE = 'REPLEACE_SELECT_DATE';
export const CHECK_FLIGHT_DATE = 'CHECK_FLIGHT_DATE';

// 选择日期
export function saveDate(data) {
  return { type: SAVE_SELECT_DATE, data };
}

// 替换日期
export function repleaceDate(data, num) {
  return { type: REPLEACE_SELECT_DATE, data, num };
}

// 清空选择日期数据
export function clearSelectDate() {
  return { type: CLEAR_SELECT_DATE };
}

// 校验日期
export function checkFlightDate(data) {
  return {
    type: 'CHECK_FLIGHT_DATE',
    payload: {
      request: {
        url: urlConfig.checkFlightDate,
        method: 'post',
        data,
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/routes/routes/selectDate/modules/actions.js